<template>
  <div class="summary-new-container" :class="{disable:disable}">
    <div v-if="disable" class="no-permission">
      <div>
        <i class="iconfont icon-queshengye_zanwuwenti" style="font-size: 250px;color: #fd889e"/>
        <h2>
          无权限访问，如有疑问？
          <el-button type="primary" round size="mini" @click="toDingDing">咨询权限</el-button>
        </h2>
      </div>
    </div>
    <template v-else>
      <affix :sticky="sticky" :organization-id.sync="condition.organization_id" @selected="selectMonth"/>
      <div style="padding: 0 20px 20px 20px">
        <!--    经营状况图表   -->
        <template v-has-module="'dashboard_summary'">
          <summary-data/>
          <el-divider/>
        </template>
        <el-tabs ref="tab" class="dashboard-tab" tab-position="right" @tab-click="handleTabClick">
          <el-tab-pane v-has-module="'monthly_summary'" label="月度总表">
            <summary-data-monthly v-if="activeTab==='月度总表'"/>
          </el-tab-pane>
          <el-tab-pane v-has-module="'brand_summary'" label="品牌行业">
            <el-row :gutter="10" v-if="activeTab==='品牌行业'">
              <el-col :span="12">
                <el-row>
                  <summary-brand-trade/>
                </el-row>
                <el-row style="padding-top: 5px;">
                  <summary-brand-category/>
                </el-row>
                <el-row style="padding-top: 5px;">
                  <summary-brand-combine/>
                </el-row>
                <el-row style="padding-top: 5px;">
                  <summary-brand-combine-year/>
                </el-row>
              </el-col>
              <el-col :span="12" style="padding-left: 5px">
                <el-row>
                  <summary-brand/>
                </el-row>
                <el-row style="padding-top: 5px;">
                  <summary-brand-place-of-origin/>
                </el-row>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane v-has-module="'platform_summary'" label="平台维度">
            <summary-platform v-if="activeTab==='平台维度'"/>
          </el-tab-pane>
          <el-tab-pane v-has-module="'ad_summary'" label="广告主维度">
            <summary-order v-if="activeTab==='广告主维度'"/>
          </el-tab-pane>
          <el-tab-pane v-has-module="'artisan_summary'" label="红人排行">
            <summary-artist v-if="activeTab==='红人排行'"/>
          </el-tab-pane>
          <el-tab-pane v-has-module="'customer_summary'" label="客户维度">
            <summary-customer v-if="activeTab==='客户维度'"/>
          </el-tab-pane>
          <el-tab-pane v-has-module="'sale_summary'" label="销售维度">
            <summary-sale v-if="activeTab==='销售维度'"/>
          </el-tab-pane>
          <el-tab-pane v-has-module="'ae_summary'" label="执行维度">
            <summary-executor v-if="activeTab==='执行维度'"/>
          </el-tab-pane>
          <el-tab-pane v-has-module="'back_money_summary'" label="回款统计">
            <summary-back-money v-if="activeTab==='回款统计'"/>
          </el-tab-pane>
          <el-tab-pane v-has-module="'investment_summary'" label="招商维度">
            <summary-investment v-if="activeTab==='招商维度'"/>
          </el-tab-pane>
        </el-tabs>
      </div>
    </template>
  </div>
</template>

<script>
import {gFunc} from "@/globalFunc";
import SummarySale from "./SummarySale";
import SummaryExecutor from "./SummaryExecutor";
import SummaryPlatform from "./SummaryPlatform";
import SummaryCustomer from "./SummaryCustomer";
import SummaryArtist from "./SummaryArtist";
import SummaryBrand from "./SummaryBrand";
import SummaryData from "./SummaryData";
import SummaryBrandCategory from "./SummaryBrandCategory";
import SummaryOrder from "./SummaryOrder";
import SummaryBrandTrade from "./SummaryBrandTrade";
import SummaryDataMonthly from "./SummaryDataMonthly/SummaryDataMonthly";
import SummaryBackMoney from "./SummaryBackMoney";
import Affix from "@/components/summary/Affix.vue";
import {lsGet} from "@/utils";
import config from "@/config";
import SummaryBrandCombine from "@/components/summary/SummaryBrandCombine.vue";
import SummaryBrandCombineYear from "@/components/summary/SummaryBrandCombineYear";
import SummaryInvestment from "@/components/summary/SummaryInvestment.vue";
import SummaryBrandPlaceOfOrigin from "@/components/summary/SummaryBrandPlaceOfOrigin.vue";

const userAuth = lsGet('userAuth')

function checkHasModule(el, binding) {
  const {value} = binding
  const hasDisplay = userAuth[value]
  if (!hasDisplay) {
    el.parentNode && el.parentNode.removeChild(el)
  }
}

export default {
  name: 'SummaryIndex',
  components: {
    SummaryInvestment,
    SummaryBrandCombine,
    SummaryBrandCombineYear,
    Affix, SummaryBackMoney, SummaryOrder, SummaryBrandTrade, SummaryBrandCategory, SummaryData, SummaryDataMonthly,
    SummaryArtist, SummaryCustomer, SummaryPlatform, SummaryExecutor, SummarySale, SummaryBrand, SummaryBrandPlaceOfOrigin
  },
  directives: {
    'has-module': {
      inserted(el, binding) {
        checkHasModule(el, binding)
      },
      update(el, binding) {
        checkHasModule(el, binding)
      }
    }
  },
  provide() {
    return {condition: this.condition}
  },
  data() {
    return {
      sticky: false,
      disable: true, // 无权限查看
      activeTab: '月度总表',
      condition: {
        year: parseInt(gFunc.parseTime(new Date(), '{y}')),
        month: parseInt(gFunc.parseTime(new Date(), '{m}')),
        organization_id: "",
      },
    }
  },
  mounted() {
    const {disable} = this.$route.query
    this.disable = !!disable
  },
  methods: {
    selectMonth(obj) {
      this.condition.year = obj.year
      this.condition.month = obj.month
    },
    handleTabClick(e) {
      this.activeTab = e.label
      const dom = this.$refs.tab.$el
      // console.log(dom.offsetTop)
      this.$emit('scrollTo', dom.offsetTop)
    },
    toDingDing() {
      window.location.href = `dingtalk://dingtalkclient/action/sendmsg?dingtalk_id=${config.DD_ADMINISTRATOR_ID}`
    },
  }
}
</script>
<style lang="scss">
.summary-new-container.disable {
  height: 100%;
}

.summary-new-container {
  background: #FFFFFF;
  border-radius: 6px;

  .no-permission {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    h2 {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 60px;
    }
  }

  .dashboard-tab {
    .el-tabs__item {
      width: 15px;
      line-height: 24px;
      writing-mode: vertical-lr;
      height: 100px;
      display: flex !important;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
